export class Message {
  text: string
  type: string

  constructor(props: Message) {
    Object.assign(this, props)
  }
}
export const MessageType = {
  Error: 'error',
  Warning: 'warning'
}

export class LoaderData {
  url: string
  baseURL?: string
  method?: string

  constructor(props: LoaderData) {
    Object.assign(this, props)
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/modules/UI/Model.ts